import * as React from "react";
import type { SVGProps } from "react";
const FoodTruck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#clip0_4355_6994)">
      <g clipPath="url(#clip1_4355_6994)">
        <path
          fill="currentColor"
          d="M4.2 2.4004c-.9938 0-1.8.8062-1.8 1.8v1.8H.6c-.33 0-.6.27-.6.6s.27.6.6.6h9.6c.33 0 .6.27.6.6s-.27.6-.6.6H1.8c-.33 0-.6.27-.6.6s.27.6.6.6H9c.33 0 .6.27.6.6s-.27.6-.6.6H.6c-.33 0-.6.27-.6.6s.27.6.6.6h7.2c.33 0 .6.27.6.6s-.27.6-.6.6H2.4v4.8c0 1.9875 1.6125 3.6 3.6 3.6s3.6-1.6125 3.6-3.6h4.8c0 1.9875 1.6125 3.6 3.6 3.6s3.6-1.6125 3.6-3.6h1.2c.6638 0 1.2-.5363 1.2-1.2s-.5362-1.2-1.2-1.2v-4.3013a2.4 2.4 0 0 0-.7012-1.6987L19.2 6.7016a2.4 2.4 0 0 0-1.6987-.7012H15.6v-1.8c0-.9938-.8062-1.8-1.8-1.8zm16.2 8.8987v.7013h-4.8v-3.6h1.9013zM6 16.2004a1.7998 1.7998 0 0 1 1.2728 3.0728 1.8003 1.8003 0 0 1-2.5456 0A1.8 1.8 0 0 1 6 16.2004m10.2 1.8a1.8 1.8 0 1 1 3.5998-.0001 1.8 1.8 0 0 1-3.5998.0001"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_4355_6994">
        <path fill="transparent" d="M0 0h24v24H0z" />
      </clipPath>
      <clipPath id="clip1_4355_6994">
        <path fill="transparent" d="M0 2.4004h24v19.2H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default FoodTruck;
